"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var HistoryError;
(function (HistoryError) {
    HistoryError["error_executing_command"] = "error_executing_command";
    HistoryError["api_connection_failed"] = "api_connection_failed";
})(HistoryError || (HistoryError = {}));
var HistoryOperationName;
(function (HistoryOperationName) {
    HistoryOperationName["getAccountHistory"] = "get_account_history";
    HistoryOperationName["searchAccountBalanceHistory"] = "search_account_balance_history";
    HistoryOperationName["getAccountBalanceForTransaction"] = "get_account_balance_for_transaction";
})(HistoryOperationName || (HistoryOperationName = {}));
var HistoryOperation = /** @class */ (function () {
    function HistoryOperation(name) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        this._name = name;
        this._parameters = params;
    }
    Object.defineProperty(HistoryOperation.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryOperation.prototype, "parameters", {
        get: function () {
            return this._parameters;
        },
        enumerable: true,
        configurable: true
    });
    return HistoryOperation;
}());
exports.HistoryOperation = HistoryOperation;
var HistoryOperations;
(function (HistoryOperations) {
    var GetAccountHistory = /** @class */ (function (_super) {
        __extends(GetAccountHistory, _super);
        function GetAccountHistory(accountId, startObjectId, endObjectId, resultNumber) {
            if (startObjectId === void 0) { startObjectId = '1.7.0'; }
            if (endObjectId === void 0) { endObjectId = '1.7.0'; }
            if (resultNumber === void 0) { resultNumber = 100; }
            return _super.call(this, HistoryOperationName.getAccountHistory, accountId, startObjectId, resultNumber, endObjectId) || this;
        }
        return GetAccountHistory;
    }(HistoryOperation));
    HistoryOperations.GetAccountHistory = GetAccountHistory;
    var SearchAccountBalanceHistory = /** @class */ (function (_super) {
        __extends(SearchAccountBalanceHistory, _super);
        function SearchAccountBalanceHistory(accountId, assetList, partnerId, fromBlockNumber, toBlockNumber, startFrom, limit) {
            return _super.call(this, HistoryOperationName.searchAccountBalanceHistory, accountId, assetList, partnerId, fromBlockNumber, toBlockNumber, startFrom, limit) || this;
        }
        return SearchAccountBalanceHistory;
    }(HistoryOperation));
    HistoryOperations.SearchAccountBalanceHistory = SearchAccountBalanceHistory;
    var GetAccountBalanceForTransaction = /** @class */ (function (_super) {
        __extends(GetAccountBalanceForTransaction, _super);
        function GetAccountBalanceForTransaction(accountId, historyObjectId) {
            return _super.call(this, HistoryOperationName.getAccountBalanceForTransaction, accountId, historyObjectId) || this;
        }
        return GetAccountBalanceForTransaction;
    }(HistoryOperation));
    HistoryOperations.GetAccountBalanceForTransaction = GetAccountBalanceForTransaction;
})(HistoryOperations = exports.HistoryOperations || (exports.HistoryOperations = {}));
var HistoryApi = /** @class */ (function () {
    function HistoryApi(api, apiConnector) {
        this._api = api;
        this._apiConnector = apiConnector;
    }
    HistoryApi.prototype.histApi = function () {
        return this._api.instance().history_api();
    };
    HistoryApi.prototype.execute = function (operation) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._apiConnector.connection()
                .then(function () {
                _this.histApi()
                    .exec(operation.name, operation.parameters)
                    .then(function (content) { return resolve(content); })
                    .catch(function (err) {
                    reject(_this.handleError(HistoryError.error_executing_command, err));
                });
            })
                .catch(function (err) { return reject(_this.handleError(HistoryError.api_connection_failed, err)); });
        });
    };
    HistoryApi.prototype.handleError = function (historyErrorMessage, err) {
        var error = new Error(historyErrorMessage);
        error.stack = err;
        return error;
    };
    return HistoryApi;
}());
exports.HistoryApi = HistoryApi;
//# sourceMappingURL=history.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/history.js
// module id = 59
// module chunks = 0